// extracted by mini-css-extract-plugin
module.exports = {"accordion__wrapper":"styles_accordion__wrapper__g2uPE"};